// extracted by mini-css-extract-plugin
module.exports = {"error_boundary":"Error_error_boundary__kic0m"};